import type { TechniqueEntry } from '../schema';

export const careTeamWillingness: TechniqueEntry = {
  key: 'care_team_willingness',
  version: '0.1',
  name: 'Care-team willingness',
  pillar: 'Practical',
  serves:
    "Gauging and honouring a member's openness to human support: offered as an option at the right moment, never pressure, never a hand-off that reads as being passed along.",
  method: [
    'Watch for the signals: asking for a person, saying this feels too big alone, escalating use, frequent relapse, feeling out of control, low mood lasting weeks, severity language (crushing, drowning), or a direct ask about therapy.',
    'Acknowledge calmly in the moment and stay with them; carry the willingness question to its natural beat (the close, or the composed counselor beat) rather than booking mid-flow.',
    'Frame as an option, not a recommendation; the member chooses, and interest volunteered earlier is noted but never treated as consent: the explicit ask still happens.',
    'On yes, the shipped booking choreography takes over; on no, respect it fully.',
  ],
  never: [
    'Never pressure, and never re-offer after a decline in the same session.',
    'Never minimise what prompted it.',
    'Never escalate a support wish as a crisis; the two have distinct protocols.',
    'Never imply the member has failed at the AI-led path, and never send them elsewhere; always offer to connect them through our network first.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'A willingness signal, or a composed beat that owns the offer.',
    },
  ],
  doneWhen:
    "The member's stance on human support is explicit: a yes carried into booking, or a no respected without residue.",
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'shared/sections/practice_constraints.md (care-team path), agents/cab/sona/prompt.md (counselor beat), agents/intake/sona-v2/prompt.md (routing guidance)',
};
